export default __webpack_public_path__ + "static/media/topicNewGame.a3770e82.png";